import { render, staticRenderFns } from "./VerifySignInCode.vue?vue&type=template&id=2079c17f&"
import script from "./VerifySignInCode.vue?vue&type=script&lang=js&"
export * from "./VerifySignInCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports